import { Injectable, signal } from '@angular/core';
import { TipoIcone, TipoNotificacao } from '../../constants/tipo-notificacao.enum';

@Injectable({
  providedIn: 'root',
})
export class NotificacaoService {
  public aviso = signal({
    exibir: false,
    tipo: TipoNotificacao.Information,
    icone: TipoIcone.Info,
    mensagem: '',
  });

  public abrir(tipo: TipoNotificacao, icone: TipoIcone, mensagem: string) {
    this.aviso.set({ exibir: true, tipo, icone, mensagem });
  }

  public ocultar() {
    this.aviso.set({ ...this.aviso(), exibir: false });
  }
}